import { create } from "zustand";

interface SidebarSettings {
  isOpen: boolean;
  isCollapsed: boolean;
  toggleSidebar: (state: boolean) => void;
  toggleCollapse: (state: boolean) => void;
}

const useSidebarSettingsStore = create<SidebarSettings>((set) => ({
  isOpen: true,
  isCollapsed: false,
  toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
  toggleCollapse: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
}));

export default useSidebarSettingsStore;
